import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VContainer,{attrs:{"full":""}},[_c(VCard,{staticClass:"ml-4 mt-10",attrs:{"max-width":"400"}},[_c(VCardText,[_c('div',{staticClass:"text-h6 mb-2"},[_vm._v("TruValidate Demo")]),_c('div',{staticClass:"text-body-2 text--secondary"},[_vm._v(" Version: "),_c('span',{staticClass:"font-weight-bold"},[_vm._v(_vm._s(_vm.version))])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }